import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import LocationsResultList from '../LocationsResultList/LocationsResultList'
import { LocationsWrapper } from '../../../SharedStyledComponents.js'

const Locations = ({
  results = [],
  selectedSearchResult,
  onItemSelected,
  searchHaveMoreResults = false,
  setShowAllResultsAction,
  totalSearchResultsLength,
  ...props
}) =>
  <LocationsWrapper>
    <LocationsResultList
      { ...props }
      results={ results }
      selectedItemIndex={ selectedSearchResult }
      selectedItemPositionHandler={ onItemSelected } />
    {
      searchHaveMoreResults &&
        <SeeMoreWrapper>
          <Button full filter onClick={ setShowAllResultsAction }>
            View All { totalSearchResultsLength } Results <Icon asset="arrow-down" width={ 10 } height={ 10 } />
          </Button>
        </SeeMoreWrapper>
    }
  </LocationsWrapper>

export default Locations

Locations.propTypes = {
  onItemSelected: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.shape()),
  searchHaveMoreResults: PropTypes.bool,
  selectedSearchResult: PropTypes.string,
  setShowAllResultsAction: PropTypes.func,
  totalSearchResultsLength: PropTypes.number
}

const SeeMoreWrapper = styled.div`
  ${Mixin.mobileOnly()}

  & ${Button} {
    color: ${Theme.colors.blue};
    ${Mixin.font.GothamMedium(14, 500)}
    text-transform: capitalize;
  }
`
